import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import LicenseStore from '../../../stores/licenses'

import OrderableTH from '../../navigation/OrderableTH'
import StorePagination from '../../navigation/StorePagination'

import Icon from '../../util/Icon'

@inject('auth')
@observer
export default class Trialing extends Component {
  state = {
    order_by: 'created_at',
    order_dir: 'desc',
    status: 'trialing',
  }

  licenses = new LicenseStore()

  componentWillMount() {
    this.loadPage()
  }

  loadPage(nextPage) {
    const { page = 1 } = this.props.location.query
    this.licenses.loadPage(nextPage || page, this.state)
  }

  componentWillReceiveProps(nextProps) {
    const { page: next, ...nextQuery } = nextProps.location.query
    const { page: prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  isAdmin() {
    return this.props.auth.user.admin
  }

  render() {
    return (
      <div className="container padded teams">
        <div className="panel full padded">
          <h2 className="title">Trialing <small>({this.licenses.totalCount} total)</small></h2>

          <table className="zebra">
            <thead>
              <tr>
                <th style={{ textAlign: 'left' }}>#</th>
                <th>Team</th>
                <th>Installed on WP?</th>
                <OrderableTH query={this.state} field="created_at">Trial Start Date</OrderableTH>
                <OrderableTH query={this.state} field="trial_ends_at">Trial End Date</OrderableTH>
              </tr>
            </thead>
            <tbody>
              {this.licenses.map((l, i) => (
                <tr key={l.id}>
                  <td><small>{this.licenses.perPage * (this.licenses.currentPage - 1) + i + 1}</small></td>
                  <td><Link to={`/teams/${l.team_id}`}>{l.team_name} {l.stripe_subscription_id && <Icon icon="cc-stripe"/>}</Link></td>
                  <td>{l.website_installations_count ? 'Yes' : 'No'}</td>
                  <td>{new Date(l.created_at).toDateString()}</td>
                  <td>{new Date(l.trial_ends_at).toDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <StorePagination store={this.licenses} query={this.state} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Trialing/index.js